import React from "react";

const AppContext = React.createContext({ isLoggedIn: false, user: {} });

export default AppContext;